module.exports = __webpack_public_path__ + "static/img/metabase.0b009d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/metabase.png
// module id = 6mg8
// module chunks = 3